// extracted by mini-css-extract-plugin
module.exports = {"TooltipText":"o-fL3o"};